// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__dI3DK","logo":"auth_logo__qxEV8","bgLayer":"auth_bgLayer__yxdso"};